<template>
  <div>
    <div class="lifestyle-pricelist-detail" v-if="!isModalLoading">
      <!-- <div v-if="quantity" class="lifestyle-pricelist-detail__row">
        <div class="subhead">Stock Availability</div>
        <h1>{{pluralize(quantity, 'item')}}</h1>
      </div> -->
      <div v-if="minPeriod && minPeriodUnit" class="lifestyle-pricelist-detail__row">
        <div class="subhead">Minimum Order Period</div>
        <h1>{{pluralize(minPeriod, minPeriodUnit)}}</h1>
      </div>
      <div v-if="minQuantity" class="lifestyle-pricelist-detail__row">
        <div class="subhead">Minimum Order Quantity</div>
        <h1>{{pluralize(minQuantity, 'item')}}</h1>
      </div>
      <div class="lifestyle-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Lead Time</span>
          <tooltip text="Lead Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey" ></i>
            </span>
        </tooltip>
        </div>
        <h1 v-if="leadTime" class="subhead">{{ pluralize(leadTime, 'Day') }}</h1>
        <h1 v-else>{{'-'}}</h1>
      </div>
      <div class="lifestyle-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Trail Time</span>
          <tooltip text="Trail Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey" ></i>
            </span>
        </tooltip>
        </div>
        <h1 v-if="trailTime"  class="subhead">{{ pluralize(trailTime, 'Day') }}</h1>
        <h1 v-else>{{'-'}}</h1>
      </div>
      <div v-if="reportTime" class="lifestyle-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">Report Time</span>
          <tooltip text="Report Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey" ></i>
            </span>
        </tooltip>
        </div>
        <h1 v-if="reportTime" class="subhead">{{ pluralize(reportTime, 'Day') }}</h1>
        <h1 v-else>{{'-'}}</h1>
      </div>
      <div class="lifestyle-pricelist-detail__row">
        <div class="subhead">
          <span class="left-title">BAST Time</span>
          <tooltip text="BAST Time">
            <span slot="content" class="btn-plus">
              <i class="adx-ic_info color-grey" ></i>
            </span>
        </tooltip>
        </div>
        <h1 v-if="BASTTime" class="subhead">{{ pluralize(BASTTime, 'Day') }}</h1>
        <h1 v-else>{{'-'}}</h1>
      </div>
      <div v-if="description" class="lifestyle-pricelist-detail__description">
        <h1 class="subhead">Description</h1>
        <div class="subhead">{{description}}</div>
      </div>
      <div  v-if="terms.length > 0" class="lifestyle-pricelist-detail__tnc">
       <h1 class="subhead">Terms & Condition</h1>
       <ul>
        <li class="subhead" v-for="(term, index) in terms" :key="index">{{term}}</li>
       </ul>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";

import { ALoadingPrimary } from "ui-kit-v1";
import tooltip from '@/components/Tooltip';

export default {
  name: "adx-lifestyle-placement-detail",
  components: {
    "a-loading": ALoadingPrimary,
    "tooltip": tooltip
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      bottomPrice: null,
      quantity: null,
      minQuantity: null,
      description: null,
      minPeriod: null,
      minPeriodUnit: null,
      leadTime: null,
      trailTime: null,
      reportTime: null,
      BASTTime: null,
      terms: []
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.lifestylePricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.quantity = data.quantity;
        this.minQuantity = data.min_quantity;
        this.description = data.description;
        this.minPeriod = data.min_period;
        this.minPeriodUnit = data.min_period_unit;
        // this.lighting = data.lighting;
        // this.orientation = data.items.map(item => item.orientation).join(", ");
        // this.width = data.items.map(item => item.width).join(", ");
        // this.height = data.items.map(item => item.height).join(", ");
        // this.unit = data.items.map(item => item.unit).join(", ");
        // this.totalSpot = data.total_spot;
        // this.position = data.position;
        // this.totalSlot = data.total_slot;
        // this.duration = data.duration_per_slot;
        // this.mediaAd = data.items.map(item => item.name).join(", ");
        this.trailTime = data.trail_time;
        this.leadTime = data.lead_time;
        this.reportTime = data.report_time;
        this.BASTTime = data.bast_time;
        this.terms = data.location.tnc.map(term => term);
      }

      this.isModalLoading = false;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }
      return `${value} ${label}`;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
